import { useServices } from "@core/servicesContext";
import { AsyncResult, PaginatedDataResult, useMappedStore, useStoredData } from "@utils/hooks";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Media } from "@domain/media/media";
import { Workspace } from "./workspace";

export function useWorkspace(id: string, slugWorkspace: string): AsyncResult<Workspace> {
	const { workspaceService } = useServices();

	const currentProfile = useCurrentProfile();
	// return useStoredData(id, workspaceService.workspaceStore, [currentProfile?.id]);
	return useStoredData(
		slugWorkspace || id,
		slugWorkspace ? workspaceService.slugWorkspaceStore : workspaceService.workspaceStore,
		[currentProfile?.id, slugWorkspace]
	);
}

export function useWorkspaces(shareroomId: string): PaginatedDataResult<Workspace> {
	const { workspaceService } = useServices();
	const currentProfile = useCurrentProfile();
	return useMappedStore(shareroomId, workspaceService.shareroomsWorkspacesStore, [shareroomId, currentProfile?.id]);
}

export function useWorkspaceAssets(workspaceId: string): PaginatedDataResult<Media> {
	const { workspaceService } = useServices();
	return useMappedStore(workspaceId, workspaceService.assetsStore, [workspaceId]);
}

export function useCourseWorkspaces(courseId: string): PaginatedDataResult<Workspace> {
	const { workspaceService } = useServices();
	return useMappedStore(courseId, workspaceService.coursesWorkspacesStore, [courseId]);
}

export function useQuizWorkspaces(quizId: string): PaginatedDataResult<Workspace> {
	const { workspaceService } = useServices();
	return useMappedStore(quizId, workspaceService.quizzesWorkspacesStore, [quizId]);
}

export function useArticlesWorkspaces(articleId: string): PaginatedDataResult<Workspace> {
	const { workspaceService } = useServices();
	return useMappedStore(articleId, workspaceService.articlesWorkspacesStore, [articleId]);
}
